import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import authService from '../../services/auth.service';
import { validators } from '../../utils/validators';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!validators.isValidEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }

        setLoading(true);
        const result = await authService.forgotPassword(email);

        if (result.success) {
            setSuccess(true);
        } else {
            setError(result.error);
        }

        setLoading(false);
    };

    if (success) {
        return (
            <div className="auth-page">
                <Link to="/" className="back-to-website-btn">
                    <span>←</span> Back to Website
                </Link>
                <div className="auth-container">
                    <div className="auth-card">
                        <div className="success-message">
                            <span className="success-icon">✓</span>
                            <h2>Check Your Email</h2>
                            <p>We've sent password reset instructions to {email}</p>
                            <Link to="/login">
                                <Button variant="primary">Back to Login</Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <Link to="/" className="back-to-website-btn">
                <span>←</span> Back to Website
            </Link>
            <div className="auth-container">
                <div className="auth-card">
                    <h1>Forgot Password?</h1>
                    <p className="auth-subtitle">Enter your email to reset your password</p>

                    {error && <div className="error-message">{error}</div>}

                    <form onSubmit={handleSubmit} className="auth-form">
                        <Input
                            label="Email"
                            type="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={error}
                            required
                        />

                        <Button
                            type="submit"
                            variant="primary"
                            disabled={loading}
                            className="auth-submit"
                        >
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </Button>
                    </form>

                    <div className="auth-footer">
                        <Link to="/login" className="back-link">
                            ← Back to Login
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
